// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { BrowserRouter } from "react-router-dom";
import * as Tooltip from "@radix-ui/react-tooltip";
import App from "./App";

import "./styles/global.css";
import "./index.css";

// ✅ Load Clerk Key
const clerkKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!clerkKey) {
  throw new Error("Missing Clerk Publishable Key");
}

// ✅ Render app WITHOUT React.StrictMode to avoid double mounting Clerk flows
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ClerkProvider publishableKey={clerkKey}>
    <Tooltip.Provider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Tooltip.Provider>
  </ClerkProvider>
);
